<script>
export default {
  name: "login-middleware",
  mounted() {
    let user_id = this.$ls.get('user_id');
    let user_phone = this.$ls.get('user_phone');

    let parentWindow = window.parent;
    if(parentWindow) {
      parentWindow.postMessage('loaded', '*');
    }
  }
}
</script>

<template>
  <div></div>
</template>

<style scoped>

</style>